import React, { useContext } from "react";
import { NavLink, Route } from "react-router-dom";
// import Cookies from 'js-cookie';
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import { Button, WindmillContext } from "@windmill/react-ui";
import { useSelector, useDispatch } from "react-redux";
import { IoLogOutOutline } from "react-icons/io5";
import logoDark from "../../assets/img/logo/logo-dark.svg";
import logoLight from "../../assets/img/logo/logo-light.svg";
import sidebar from "../../routes/sidebar";
import './SideBaar.css';

import { AdminContext } from "../../context/AdminContext";
import { useHistory } from "react-router-dom";
import { logoutOperator } from "../../../actions/auth";

const SidebarContent = () => {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const history = useHistory();
  const isLogin = cookies.get("auth");
  const { mode } = useContext(WindmillContext);

  const handleLogOut = () => {
    Swal.fire({
      icon: "warning",
      title: "",
      text: "Do you really want to Sign-out ?",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        // Clear cookies
        dispatch(logoutOperator(history));
        history.push("/operator/login");
      }
    });
  };


  return (
    <div className="py-4 text-gray-500">
      <div className="text-gray-900" style={{ textDecoration: "underline" }}>
        <h1 style={{ marginLeft: "1.5rem", fontSize: "1.3rem" }}>
          Operator's Panel
        </h1>
      </div>
      <ul className="mt-8">
        {sidebar.map((route) => (
          <li className="relative" key={route.name}>
            <NavLink
              exact
              to={route.path}
              className="px-6 py-4 inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-green-700"
              activeClassName="text-green-500"
            >
              <Route path={route.path} exact={route.exact}>
                <span
                  className="absolute inset-y-0 left-0 w-1 bg-green-500 rounded-tr-lg rounded-br-lg addBusBtnHomeIndi"
                  aria-hidden="true"
                ></span>
              </Route>
              <route.icon className="w-5 h-5" aria-hidden="true" />
              <span className="ml-4">{route.name}</span>
            </NavLink>
          </li>
        ))}
      </ul>
      <span className="lg:fixed bottom-0 px-6 py-6 w-64 mx-auto relative mt-3 block">
        <button
          onClick={handleLogOut}
          size="large"
          className="w-full logOutBtnSideBar"
        >
          <span className="flex items-center">
            <IoLogOutOutline
              className="mr-3 text-lg"
            />
            <span className="text-sm">Log out </span>
          </span>
        </button>
      </span>
    </div>
  );
};

export default SidebarContent;
